@if (isActive()) {
  <div class="guide-overlay" guideTopLayer aria-hidden="true">
    <!-- Dimming backdrop with a spotlight cutout over the target element. -->
    @if (spotlight(); as rect) {
      <div
        class="guide-overlay__spotlight"
        [style.top.px]="rect.top"
        [style.left.px]="rect.left"
        [style.width.px]="rect.width"
        [style.height.px]="rect.height"
      ></div>
    }

    <!-- Synthetic cursor. -->
    @if (cursor.visible()) {
      <div
        class="guide-overlay__cursor"
        [style.transform]="'translate3d(' + cursor.position().x + 'px, ' + cursor.position().y + 'px, 0)'"
      >
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 3l14 8-6.5 1.5L9 19 5 3z"
            fill="#ffffff"
            stroke="#111827"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    }
  </div>

  <!-- Narration callout — anchored below the spotlight; interactive. -->
  @if (step(); as currentStep) {
    <div
      class="guide-callout"
      guideTopLayer
      role="status"
      aria-live="polite"
      [style.top.px]="(spotlight()?.top ?? 24) + (spotlight()?.height ?? 0) + 12"
      [style.left.px]="spotlight()?.left ?? 24"
    >
      <p class="guide-callout__progress">Step {{ stepNumber() }} of {{ totalSteps() }}</p>
      <p class="guide-callout__narration">{{ currentStep.narration }}</p>
      @if (awaitingUser()) {
        <p class="guide-callout__hint">Waiting for you to click…</p>
      }
    </div>
  }
}
